import React from 'react';
import './_button.scss';
import styled from "styled-components";
import Icon from "../icon/Icon";
import { BaseButton, ButtonSize, NewButtonProps } from "./ButtonStyling";
import Colours from "../Colours";
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";

export function PrimaryButton(props: NewButtonProps) {
  const {t} = useTranslation();

  let buttonAttributes = {}
  if (!!props.dataTest) {
    // @ts-ignore
    buttonAttributes['data-test'] = props.dataTest;
  }

  if (props.link) {
    const linkBtnProps = {
      ...buttonAttributes,
      ...props,
    }
    return <PrimaryLinkButton {...linkBtnProps} />
  }

  return (
    <PrimaryButtonWrapper {...buttonAttributes}
                          className={props.className ?? ''}
                          fullWidth={!!props.fullWidth}
                          size={props.size || ButtonSize.Medium}
                          disabled={!!props.disabled}
                          type={props.buttonType ?? 'button'}
                          style={props?.style ?? {}}
                          onClick={(e: any) => props.click ? props.click(e) : () => {}}>
      {props.icon && <Icon style={{marginRight: 8}} icon={props.icon ?? ''}/>}
      {props.text && <span>{!!props.text ? t(props.text) : ''}</span>}
    </PrimaryButtonWrapper>
  );
}

function PrimaryLinkButton(props: NewButtonProps) {
  const linkButtonProps = {
    ...props,
    link: undefined,
  }
  return <Link to={props.link ?? '#'} style={props.style ?? {}} className={"linkButton"}>
    <PrimaryButton {...linkButtonProps} />
  </Link>
}

const PrimaryButtonWrapper = styled(BaseButton)<any>`
  background-color: ${props => !!props.disabled ? Colours.mildGrey : Colours.blue};
  color: white;
  border: 0;
  &:hover {
    background-color: ${props => !!props.disabled ? Colours.mildGrey : Colours.darkBlue};
  }

  /* The icon font sets its own colour, so it needs telling that this button is a dark one. */
  i {
    color: white;
  }
`
